import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export default function PaypalSubscribeButton({ onSuccess }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/paypal/config").then((r) => setCfg(r.data)).catch(() => setCfg(false));
  }, []);

  if (cfg === null) return <div className="text-xs text-zinc-500 py-2" data-testid="paypal-loading">Loading PayPal…</div>;
  if (!cfg || !cfg.client_id) return <div className="text-xs text-red-400 py-2" data-testid="paypal-unavailable">PayPal is currently unavailable.</div>;

  return (
    <div data-testid="paypal-subscribe" className="min-h-[48px]">
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: cfg.currency || "USD", intent: "subscription", vault: true, dataNamespace: "paypalSub" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "pill", label: "subscribe" }}
          createSubscription={(d, actions) => actions.subscription.create({ plan_id: cfg.plan_id })}
          onApprove={async (data) => {
            try {
              const res = await api.post("/paypal/subscribe", { subscription_id: data.subscriptionID });
              onSuccess?.(res.data);
            } catch (e) { toast.error(apiErr(e)); }
          }}
          onError={() => toast.error("PayPal error. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
